import React from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, ArrowRight, Music2 } from "lucide-react";
import { catMeta } from "../lib/categories";

const dayLabel = (iso) => {
  const d = new Date(iso.length <= 10 ? iso + "T00:00" : iso);
  return d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
};
const timeLabel = (iso) => {
  if (!iso || iso.length <= 10) return "";
  return new Date(iso).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
};

// Groups events by day and renders the dark card grid used across discovery pages.
export default function EventDayGroups({ events, testidPrefix = "evt" }) {
  const groups = {};
  (events || []).forEach((e) => {
    const key = (e.event_date || "").slice(0, 10) || "tbc";
    (groups[key] = groups[key] || []).push(e);
  });
  const dates = Object.keys(groups).sort();

  return (
    <div className="space-y-10">
      {dates.map((date) => (
        <div key={date} data-testid={`${testidPrefix}-day-${date}`}>
          <div className="flex items-center gap-3 mb-4">
            <div className="flex items-center gap-2 text-white font-semibold min-w-0">
              <CalendarDays size={18} className="text-[#2ec9c9] shrink-0" />
              <span className="truncate">{date === "tbc" ? "Date to be confirmed" : dayLabel(date)}</span>
            </div>
            <span className="text-xs text-[#8a97a8] bg-white/5 rounded-full px-2.5 py-1 shrink-0">{groups[date].length} event{groups[date].length !== 1 ? "s" : ""}</span>
            <div className="flex-1 h-px bg-white/10 min-w-[8px]" />
          </div>
          <div className="grid sm:grid-cols-2 gap-4">
            {groups[date].map((e) => {
              const cm = catMeta(e.category); const CIcon = cm.icon;
              return (
                <a key={e.id} href={`/store/${e.business_slug}/events/${e.slug}`} data-testid={`${testidPrefix}-card-${e.id}`}
                  className="group flex gap-4 rounded-2xl bg-white/[0.04] border border-white/10 p-3 min-w-0 w-full hover:bg-white/[0.08] hover:border-[#2ec9c9]/40 transition-colors">
                  <div className="w-20 h-20 rounded-xl bg-white/10 overflow-hidden shrink-0 flex items-center justify-center">
                    {e.image_url ? <img src={e.image_url} alt={e.title} className="w-full h-full object-cover" /> : <Music2 size={22} className="text-[#8b5cf6]/70" />}
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs text-[#2ec9c9]">{timeLabel(e.event_date)}</p>
                    <h3 className="text-white font-semibold truncate group-hover:text-[#2ec9c9] transition-colors">{e.title}</h3>
                    <p className="text-xs text-[#8a97a8] mt-0.5 truncate">{e.business_name}</p>
                    <div className="flex items-center gap-2 mt-1 min-w-0">
                      {e.category && <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full flex items-center gap-1 shrink-0" style={{ background: cm.color + "26", color: cm.color }}><CIcon size={10} /> {e.category}</span>}
                      {e.venue_name && <span className="text-xs text-[#8a97a8] flex items-center gap-1 truncate min-w-0"><MapPin size={11} className="shrink-0" /> <span className="truncate">{e.venue_name}</span></span>}
                    </div>
                  </div>
                  <div className="self-center text-right shrink-0">
                    {e.sold_out ? (
                      <span className="inline-block text-[11px] font-bold px-2 py-1 rounded-full bg-[#c0392b] text-white" data-testid={`${testidPrefix}-soldout-${e.id}`}>Sold out</span>
                    ) : (
                      <>
                        <p className="text-white font-bold text-sm">£{Number(e.from_price || 0).toFixed(2)}</p>
                        {e.low_stock ? <p className="text-[10px] font-bold text-[#ff6b6b]" data-testid={`${testidPrefix}-lowstock-${e.id}`}>Only {e.tickets_left} left!</p> : <p className="text-[10px] text-[#8a97a8]">from</p>}
                      </>
                    )}
                    <ArrowRight size={16} className="text-[#8a97a8] group-hover:text-[#2ec9c9] transition-colors ml-auto mt-1" />
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export { Link };
